'use strict';

import VZTcBaseCard from './VZTcBaseCard';

/**
 * @class VZTcContractDuration
 * @extends VZTcBaseCard
 * @description Handles the Teams Calling contract duration card
 */
export default class VZTcContractDuration extends VZTcBaseCard {
    /**
     * @function connectedCallback
     * @description Sets up the card and event listeners
     */
    connectedCallback() {
        super.initializeCard();

        this.radio = this.querySelector('.custom-control-input');

        this.boundChange = this.boundChange.bind(this);
        this.radio.addEventListener('change', this.boundChange);
    }

    /**
     * @function disconnectedCallback
     * @description Removes event listeners when element is removed from the DOM
     */
    disconnectedCallback() {
        super.disconnectedCallback();
    }

    /**
     * @function boundChange
     * @description Handles selection changes, updates configuration and enables/disables the next card
     * @param {CustomEvent} evt - The event from updating the radio button
     */
    boundChange(evt) {
        const selected = evt.target.parentElement;

        // Emit configuration update event
        const questionId = this.getAttribute('data-question-id');
        const productId = selected.getAttribute('data-product-id');

        this.updateConfig('variation', questionId, { pid: productId });
    }
}

if (!window.customElements.get('vz-tc-contract-duration')) {
    window.customElements.define('vz-tc-contract-duration', VZTcContractDuration);
}
